import { createStore } from 'jotai';

export const JotaiStore = createStore();
